module.exports = __webpack_public_path__ + "img/note-medical.6383e29b.svg";